import * as React from 'react'

const SvgListCheckedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5h8.75v1.25H10V5zM3.75 6.619L2.131 5l-.881.881 2.5 2.5 5-5-.881-.881L3.75 6.619zM10 13.75h8.75V15H10v-1.25zm-6.25 1.619L2.131 13.75l-.881.881 2.5 2.5 5-5-.881-.881-4.119 4.119z"
      fill="#163250"
    />
  </svg>
)

export default SvgListCheckedIcon
